import { ck, interact } from "fire-wind-water";
import service from "../service/form";
import { settingMeetingData } from "../common/settingData";
import * as sbaseData from "../common/sbase";
import { $extras } from "../../stempcore/src/core/sextra";
import moment from "moment";
export default {
  data() {
    return {
      seminarInfo: {},
      posterInfo: {},
      posterUrl: "",
      isSetting: sbaseData.isSetting,
    };
  },
  methods: {
    /* 获取海报信息 */
    getPostInfo() {
      let param = {
        instanceId: sbaseData.instanceId,
        globalUserId: ck.cookie("globalUserId"),
        expandInfo: ["poster"],
      };
      service.getTopicTemplateSeminar(param).then((data) => {
        if (data.content) {
          this.posterInfo = data.content;

          this.posterUrl = `${window.location.protocol}${
            data.content.poster.wap ? data.content.poster.wap.formalUrl : ""
          }${data.content.weChatId || ""}&schemaId=${
            data.content.schemaId || 0
          }`;
          if (typeof this.getSignUpStatus === "function") {
            this.getSignUpStatus();
          }
        }
      });
    },

    /* 获取会议信息 */
    getEventInfo() {
      if (sbaseData.isSetting) {
        this.seminarInfo = settingMeetingData;
        document.body.style.setProperty(
          "--themeColor",
          "rgba(20, 104, 249, 1)"
        );
        document.body.style.setProperty(
          "--themeColorClear",
          "rgba(20, 104, 249, .2)"
        );
        return;
      }
      if (interact.isMobile) {
        this.getPostInfo();
      }
      this.getPostInfo();
      let param = {
        instanceId: sbaseData.instanceId,
        globalUserId: ck.cookie("globalUserId"),
      };
      service.getTopicTemplateSeminar(param).then((data) => {
        if (data.content) {
          this.seminarInfo = data.content;
          // i18n: 应用会议数据的多语言翻译
          var lang = (window.$sk && window.$sk.$lang) || "zh_CN";
          if (
            lang !== "zh_CN" &&
            data.content.i18n &&
            data.content.i18n.seminar
          ) {
            var langKey = lang.toLowerCase();
            var si18n = data.content.i18n.seminar[langKey];
            if (si18n) {
              if (si18n.title) this.seminarInfo.title = si18n.title;
              if (si18n.address) this.seminarInfo.address = si18n.address;
              if (si18n.desc) this.seminarInfo.desc = si18n.desc;
              if (si18n.descWap) this.seminarInfo.descWap = si18n.descWap;
            }
          }
          // i18n: 页面标题跟随语言
          if (this.seminarInfo.title) {
            document.title = this.seminarInfo.title;
          }
          const param = {
            tenantId: this.tenantId,
            configId: data.content.topicConfigId,
          };

          service.getTemplateConfig(param).subscribe((res) => {
            if (res.result == 0) {
              const extras = $extras(res.content.info.html).extras;
              if (extras.themecolor && extras.themecolor.bgcolor) {
                let themeColorClear = "";
                const rgbaAttr = extras.themecolor.bgcolor.match(/[\d.]+/g);
                if (rgbaAttr.length >= 3) {
                  let r, g, b;
                  r = rgbaAttr[0];
                  g = rgbaAttr[1];
                  b = rgbaAttr[2];
                  themeColorClear =
                    "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
                }

                document.body.style.setProperty(
                  "--themeColor",
                  extras.themecolor.bgcolor
                );
                document.body.style.setProperty(
                  "--themeColorClear",
                  themeColorClear
                );
              }
              console.log(11111);
              this.$store.commit("setExtras", extras);

              //this.extras.formfield.model = 'style1-wap'
            } else {
              window.$sk.tips.show(res.desc);
            }
          });
        }
      });
    },

    handleTimeStampToDateTime(timeStamp, format) {
      var lang = (window.$sk && window.$sk.$lang) || "zh_CN";
      var locale = "zh-cn";
      if (lang === "en_US") locale = "en";
      else if (lang === "zh_TW") locale = "zh-tw";
      return moment(timeStamp).locale(locale).format(format);
    },
    handleTimeStamps(startTimeStamp, endTimeStamp) {
      var lang = (window.$sk && window.$sk.$lang) || "zh_CN";
      var fullFmt, dateFmt, shortDateFmt;
      if (lang === "en_US") {
        fullFmt = "MMM DD, YYYY HH:mm";
        dateFmt = "MMM DD, YYYY";
        shortDateFmt = "MMM DD";
      } else if (lang === "zh_TW") {
        fullFmt = "YYYY年MM月DD日 HH:mm";
        dateFmt = "YYYY年MM月DD日";
        shortDateFmt = "MM月DD日";
      } else {
        fullFmt = "YYYY年MM月DD日 HH:mm";
        dateFmt = "YYYY年MM月DD日";
        shortDateFmt = "MM月DD日";
      }
      let startTimeYear = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY"
      );
      let endTimeYear = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY"
      );
      let startDate = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      let endDate = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      if (startDate == endDate) {
        return (
          this.handleTimeStampToDateTime(startTimeStamp * 1000, fullFmt) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, "HH:mm")
        );
      } else if (startTimeYear == endTimeYear) {
        return (
          this.handleTimeStampToDateTime(startTimeStamp * 1000, dateFmt) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, shortDateFmt)
        );
      } else {
        return (
          this.handleTimeStampToDateTime(startTimeStamp * 1000, dateFmt) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, dateFmt)
        );
      }
    },
  },
};
